import { gql, gql as gqlb, disableFragmentWarnings } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { AddToCartButtonFragment } from './add_to_cart_button';
import { ListingGreatValueFragment } from '../listing_great_value';
import { ListingCreateOfferButtonFragment } from '../offers/create_offer_button';
import { WatchBadgeFragment } from './watch_badge';

/*
 * Disable warnings for duplicate ListingImagesFields fragment
 * Duplicate fragments warning is only disabled for this file
 */
disableFragmentWarnings();

const ListingsBumpKeyFieldsFragment = gql`
  fragment BumpKey on Listing {
    _id
    bumpKey {
      key
    }
  }
`;

const ListingsFinancingFieldsFragment = gql`
  fragment FinancingFields on Listing {
    _id
    estimatedMonthlyPaymentPlan {
      estimatedMonthlyPayment {
        display
      }
    }
  }
`;

const ListingsImagesCardSquareFragment = gql`
  fragment ListingsImagesFields on Listing{
    _id
    images(input: {
      transform: "card_square",
      count: 3,
      scope: "photos",
      type: "Product"
    }) {
      source
    }
  }
`;

/* Use gql alias to avoid duplicate ListingsImagesFields in rql.ts */
const ListingsImagesLargeSquareFragment = gqlb`
  fragment ListingsImagesFields on Listing{
    _id
    images(input: {
      transform: "large_square",
      count: 3,
      scope: "photos",
      type: "Product"
    }) {
      source
    }
  }
`;

const ListingsShopFieldsFragment = gql`
  fragment ShopFields on Listing {
    _id
    shop {
      _id
      address {
        _id
        locality
        countryCode
        region
      }
    }
  }
`;

const ListingsCollectionFragment = buildListingsCollectionFragment(ListingsImagesCardSquareFragment);
const ListingsCollectionLargeFragment = buildListingsCollectionFragment(ListingsImagesLargeSquareFragment);

const ListingsCollectionFragments = {
  bumpKey: ListingsBumpKeyFieldsFragment,
  financingFields: ListingsFinancingFieldsFragment,
  listing: ListingsCollectionFragment,
  listingLarge: ListingsCollectionLargeFragment,
  shopFields: ListingsShopFieldsFragment,
};
export default ListingsCollectionFragments;


function buildListingsCollectionFragment(imagesFragment: DocumentNode): DocumentNode {
  return gql`
    fragment ListingsCollection on Listing {
      _id
      id
      bumped
      categoryUuids
      slug
      title
      description
      listingType
      condition {
        displayName
        conditionSlug
      }
      price {
        amountCents
        display
      }
      pricing {
        buyerPrice {
          display
          currency
          amountCents
        }
        originalPrice {
          display
        }
        ribbon {
          display
          reason
        }
      }
      ...ListingsImagesFields
      watching
      state
      stateDescription
      shipping {
        shippingPrices {
          _id
          shippingMethod
          carrierCalculated
          destinationPostalCodeNeeded
          rate {
            amount
            amountCents
            currency
            display
          }
        }
        freeExpeditedShipping
        localPickupOnly
      },
      shop {
        _id
        address {
          _id
          country {
            _id
            countryCode
            name
          }
        }
      }
      ...AddToCartButtonFields
      ...WatchBadgeData
      ...ListingGreatValueData
      ...ListingCreateOfferButtonData
    }
    ${imagesFragment}
    ${WatchBadgeFragment}
    ${AddToCartButtonFragment}
    ${ListingGreatValueFragment}
    ${ListingCreateOfferButtonFragment}
  `;
}
